import { Workbox } from "workbox-window";

// Registra il service worker solo in produzione; aggiorna l'app appena esce una nuova versione.
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;
  const wb = new Workbox(`${process.env.PUBLIC_URL}/service-worker.js`);
  let ricaricando = false;
  wb.addEventListener("waiting", () => wb.messageSkipWaiting());
  wb.addEventListener("controlling", (e) => {
    if (e.isUpdate && !ricaricando) {
      ricaricando = true;
      window.location.reload();
    }
  });
  wb.register().catch(() => {});
  // Controlla aggiornamenti quando l'app torna in primo piano (tipico su iPad)
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") wb.update().catch(() => {});
  });
}
